import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { orderimg1, return_pic } from "../../constants";
import Logout from "./Logout";
import Sidebar from "./Sidebar";
import "../../assets/css/return-detail.css";
import AuthHeader from "../../components/AuthHeader/AuthHeader";
const Return_detail = () => {
	return (
		<>
			<AuthHeader />
			{/* My adresses starts here */}
			<section className="my-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Sidebar />
						</div>
						<div className="col-lg-9">
							<Logout />
							{/* return request starts here */}
							<div className="return-detail-wrapper">
								<div className="return-heading-wrapper">
									<h3>Return Requests</h3>
								</div>
								<div className="order-return-wrapper">
									<div className="order-id-wrapper">
										<span>Order #12345 was placed on 29 October 2022</span>
									</div>
									<div className="return-details-wrapper">
										<h5>Refund Detail</h5>
									</div>
									<div className="retun-pro-headi-wrapper">
										<h5>Return Product</h5>
									</div>
									<div className="product-refund-wrapper">
										<div className="img-wrapper">
											<figure>
												<img src={orderimg1} className="img-fluid" alt="" />
											</figure>
										</div>
										<div className="refund-content-wrapper">
											<div className="head-date-wrapper">
												<h5>Sweet Black Shirt </h5>
												<h6>Delivery Date</h6>
											</div>
											<div className="size-wrapper">
												<div className="size-ql-wrapper">
													<ul>
														<li>Size L</li>
														<li>Quantity 2</li>
													</ul>
												</div>
												<div className="size-date-wrapper">
													<span>10/11/22</span>
												</div>
											</div>
											<div className="price-wrapper">
												<h5>RS : $22.00</h5>
											</div>
										</div>
									</div>
									<div className="return-reason-wrapper">
										<div className="reason-heading-wrapper">
											<h5>Return Reason</h5>
										</div>
										<input
											type="text"
											className="form-control"
											placeholder="This product is not mine"
										/>
									</div>
									<div className="return-picctures-wrapper">
										<div className="pictures-head-wrapper">
											<h5>Return Products Pictures</h5>
										</div>
										<div className="pictures-wrapper">
											<img src={return_pic} className="img-fluid" alt="" />
											<img src={return_pic} className="img-fluid" alt="" />
											<img src={return_pic} className="img-fluid" alt="" />
										</div>
									</div>
									<div className="comment-head-wrapper">
										<h5>Comment</h5>
									</div>
									<div className="comment-wrapper">
										<p>
											Lorem ipsum dolor sit amet, consectetur adipiscing elit,
											sed do eiusmod tempor incididunt ut labore et dolore magna
											aliqua. Ut enim ad minim veniam, quis nostrud exercitation
											ullamco laboris nisi ut aliquip ex ea commodo consequat.
										</p>
									</div>
								</div>
							</div>
							{/* return request ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* My adresses ends here */}
			<Footer />
		</>
	);
};

export default Return_detail;
